module.exports = __webpack_public_path__ + "static/media/multifamily_strategy.0086c28c.jpg";